import { useState, useEffect, useCallback, useMemo } from "react";
import OrganisationLayout from "../layout/OrganisationLayout";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useSelector, useDispatch } from "react-redux";
import { getOrganisationRoleAccess } from "../utils/roleAccess";
import InviteMemberOrganisationModal from "../../modals/InviteMemberOrganisationModal";
import {
  organisationGroupsListAction,
  organisationRemoveOrganisationAction,
} from "../../Redux/Action/OrganisationAction";

const formatDisplayDate = (value) => {
  if (!value) return "-";

  return new Date(value).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export default function OrganisationGroupsMemberOrganisations() {
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const access = getOrganisationRoleAccess(userData);
  const dispatch = useDispatch();
  const organisationGroupId = userData?.organisationGroupId?._id;
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [activeRemoveId, setActiveRemoveId] = useState("");
  const [tableData, setTableData] = useState([]);
  const [tableMeta, setTableMeta] = useState({
    total: 0,
    page: 0,
    limit: 10,
    totalPages: 0,
  });

  const fetchOrganisations = useCallback(
    async (search = "") => {
      if (!organisationGroupId) {
        setTableData([]);
        setTableMeta({
          total: 0,
          page: 0,
          limit: 10,
          totalPages: 0,
        });
        return;
      }

      setIsLoading(true);

      const response = await dispatch(
        organisationGroupsListAction({
          groupId: organisationGroupId,
          page: 0,
          limit: 10,
          search,
        }),
      );

      const payload = response?.payload?.data;
      const organisations =
        payload?.organisations ||
        payload?.organisationsList ||
        payload?.rows ||
        payload?.data ||
        [];

      if (payload) {
        setTableData(Array.isArray(organisations) ? organisations : []);
        setTableMeta({
          total: payload?.total || 0,
          page: payload?.page || 0,
          limit: payload?.limit || 10,
          totalPages: payload?.totalPages || 0,
        });
      } else {
        setTableData([]);
        setTableMeta({
          total: 0,
          page: 0,
          limit: 10,
          totalPages: 0,
        });
      }

      setIsLoading(false);
    },
    [dispatch, organisationGroupId],
  );

  useEffect(() => {
    fetchOrganisations(searchValue);
  }, [fetchOrganisations, searchValue]);

  const pendingInvitesCount = useMemo(() => {
    return 0;
  }, []);

  const totalTeacherCount = useMemo(() => {
    return tableData.reduce(
      (sum, organisation) => sum + Number(organisation?.teacherCount || 0),
      0,
    );
  }, [tableData]);

  const totalLearnerCount = useMemo(() => {
    return tableData.reduce(
      (sum, organisation) => sum + Number(organisation?.learnerCount || 0),
      0,
    );
  }, [tableData]);

  const handleModalClose = () => {
    setShowInviteModal(false);
  };

  const handleRemoveOrganisation = async (row) => {
    const schoolId =
      row?.schoolId?._id ||
      row?.schoolId ||
      row?._id ||
      row?.organisationId ||
      "";

    if (!organisationGroupId || !schoolId) {
      console.log("remove organisation skipped", {
        organisationGroupId,
        schoolId,
        row,
      });
      return;
    }

    setActiveRemoveId(schoolId);

    const response = await dispatch(
      organisationRemoveOrganisationAction({
        groupId: organisationGroupId,
        schoolId,
      })
    );

    console.log("organisationRemoveOrganisationAction response", response?.payload);

    setActiveRemoveId("");

    if (!response?.error) {
      fetchOrganisations(searchValue);
    }
  };

  return (
    <OrganisationLayout>
      <Container fluid>
        <div className="heading-top mt-5 mb-2">
          <p className="organization-crumb">Organisation Group</p>
          <h2>Member Organisations</h2>
        </div>

        {/* <div className="organisation-page-intro">
          <p>
            Manage the organisations inside the group with the same card depth,
            button styles, and spacing already used across the portal.
          </p>
        </div> */}

        {/* <Row className="g-4">
          <Col md={3}>
            <div className="organisation-groups-card organisation-stat-card organisation-stat-card-compact">
              <span className="organisation-card-kicker">
                Active Organisations
              </span>
              <strong className="organisation-groups-stat">
                {tableMeta.total}
              </strong>
              <p>Member organisations currently returned for this group.</p>
            </div>
          </Col>
          <Col md={3}>
            <div className="organisation-groups-card organisation-stat-card organisation-stat-card-compact">
              <span className="organisation-card-kicker">Teacher Accounts</span>
              <strong className="organisation-groups-stat">
                {totalTeacherCount}
              </strong>
              <p>Total teacher and admin accounts across members.</p>
            </div>
          </Col>
          <Col md={3}>
            <div className="organisation-groups-card organisation-stat-card organisation-stat-card-compact">
              <span className="organisation-card-kicker">Learner Accounts</span>
              <strong className="organisation-groups-stat">
                {totalLearnerCount}
              </strong>
              <p>Combined learner footprint across member organisations.</p>
            </div>
          </Col>
          <Col md={3}>
            <div className="organisation-groups-card organisation-stat-card organisation-stat-card-compact">
              <span className="organisation-card-kicker">Pending Invites</span>
              <strong className="organisation-groups-stat">
                {pendingInvitesCount}
              </strong>
              <p>Outstanding organisation invitations awaiting action.</p>
            </div>
          </Col>
        </Row> */}

        <Row className="g-3 align-items-center mt-1">
          <Col xl={4} lg={5}>
            <div className="organisation-search-shell">
              <input
                type="text"
                placeholder="Search organisations"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>
          </Col>
          {access.canInviteMemberOrganisation && (
            <Col
              xl={8}
              lg={7}
              className="create-new-btn d-flex justify-content-end"
            >
              <button
                className="cmn-pink"
                onClick={() => setShowInviteModal(true)}
              >
                Invite Member Organisation
              </button>
            </Col>
          )}
        </Row>

        {!access.canInviteMemberOrganisation && (
          <div className="organisation-note-banner">
            Your role can view member organisations but cannot invite new ones.
          </div>
        )}

        <section className="organisation-groups-table-shell organisation-groups-table-shell-space">
          <div className="organisation-panel-heading">
            <div>
              <h3>Organisation list</h3>
            </div>
          </div>
          <div className="organisation-table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Organisation Name</th>
                  <th>Joined Peerscroller</th>
                  <th>Joined Organisation Group</th>
                  <th>Learners</th>
                  <th>Parents</th>
                  <th>Teachers</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {isLoading && (
                  <tr>
                    <td colSpan={7} className="text-center py-5">
                      Loading organisations...
                    </td>
                  </tr>
                )}
                {!isLoading && tableData.length === 0 && (
                  <tr>
                    <td colSpan={7} className="text-center py-5">
                      No member organisations found.
                    </td>
                  </tr>
                )}
                {!isLoading &&
                  tableData.map((row) => (
                    <tr
                      key={`${row?.organisationName}-${row?.joinedOrganisationGroup}`}
                    >
                      <td>
                        <div className="organisation-name-cell">
                          <strong>{row?.organisationName || "-"}</strong>
                          <p>Member organisation overview</p>
                        </div>
                      </td>
                      <td>{formatDisplayDate(row?.joinedPeerscroller)}</td>
                      <td>{formatDisplayDate(row?.joinedOrganisationGroup)}</td>
                      <td>{row?.learnerCount ?? 0}</td>
                      <td>{row?.parentCount ?? 0}</td>
                      <td>{row?.teacherCount ?? 0}</td>
                      <td>
                        {access.canRemoveMemberOrganisation ? (
                          <button
                            className="organisation-inline-action"
                            onClick={() => handleRemoveOrganisation(row)}
                            disabled={
                              activeRemoveId ===
                              (row?.schoolId?._id ||
                                row?.schoolId ||
                                row?._id ||
                                row?.organisationId)
                            }
                          >
                            {activeRemoveId ===
                            (row?.schoolId?._id ||
                              row?.schoolId ||
                              row?._id ||
                              row?.organisationId)
                              ? "Removing..."
                              : "Remove from Group"}
                          </button>
                        ) : (
                          <span className="organisation-inline-placeholder">
                            No actions
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </section>
      </Container>
      <InviteMemberOrganisationModal
        show={showInviteModal}
        handleClose={handleModalClose}
        onInviteSent={() => fetchOrganisations(searchValue)}
      />
    </OrganisationLayout>
  );
}
